import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterWebsiteUser_template} from "./filterWebsiteUser_template";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {imageWidget_template} from "./imageWidget_template";
import {filterAutocomplete_template } from "./filterAutocomplete_template";
import {filterTag_template } from "./filterTag_template";
import { modFileUploader_template } from "./modFileUploader_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";


declare var ko: any;
declare var Dropzone: any;

export class modEdit_template extends vnTemplate {

    public userFilter: filterWebsiteUser_template;
    public filterTagByType: filterAutocomplete_template;
    public filterModType: filterTag_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public imageWidgetForPrimaryImage: imageWidget_template;
    public imageWidgetForOtherImages: imageWidget_template;
    public fileUploader: modFileUploader_template;
    public instructionsTooltip: infoButton_template;

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Mod Editor</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="w-form-body no-border">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Information</strong>
                </div>
            </div>

            <div class="w-form-body">

                <div class="form-body no-padding">

                    <!-- Mod Title -->
                    <div class="form-group">
                        <label for="mod-title" class="form-label form-label-box">Title</label>
                        <input type="text" class="input-text" id="mod-title" data-bind="value: title" required>
                    </div>

                    <!-- Short description (plain text, max 140 chars on save) -->
                    <div class="form-group">
                        <label for="mod-short-description" class="form-label form-label-box">Short description</label>
                        <textarea id="mod-short-description" class="input-text" rows="4" maxlength="140" data-bind="value: shortDescription" placeholder="Optional summary (max 140 characters)"></textarea>
                    </div>

                    <!-- Modder Username -->
                    <div class="form-group">
                        <label for="modder" class="form-label form-label-box">Modder</label>
                        ` + this.userFilter.getHtmlBuild() + `
                    </div>

                    <!-- Status -->
                    <div class="form-group">
                        <label for="game-tag" class="form-label form-label-box">Status</label>
                        <select id="game-tag" data-bind="options: status, optionsText: 'name', optionsValue: 'id', value: selectedStatus" required></select>
                    </div>

                    <!-- Adult-only -->
                    <div class="form-group">
                        <label class="form-label form-label-box" for="mod-is-adult-only">Content rating</label>
                        <div class="form-group" style="margin-left: 0;">
                            <label class="form-label" style="font-weight: normal;">
                                <input type="checkbox" id="mod-is-adult-only" data-bind="checked: isAdultOnly" style="display: inline-block;"/>
                                Adult-only mod (18+)
                            </label>
                        </div>
                    </div>

                    <!-- GGP Opt-in -->
                    <div class="form-group">
                        <label class="form-label form-label-box" for="mod-ggp-opt-in">GGP</label>
                        <div class="form-group" style="margin-left: 0;">
                            <label class="form-label" style="font-weight: normal;">
                                <input type="checkbox" id="mod-ggp-opt-in" data-bind="checked: ggpOptIn" style="display: inline-block;"/>
                                Opt in to GGP points
                            </label>
                        </div>
                    </div>

                </div>

                <div class="form-body no-padding">

                    <!-- Game Tag -->
                    <div class="form-group" style="margin-top: 2rem;">
                        ` + this.filterTagByType.getHtmlBuild() + `
                    </div>

                    <!-- Mod Type -->
                    <div class="form-group">
                        <label for="mod-type" class="form-label form-label-box">Mod Type</label>
                        ` + this.filterModType.getHtmlBuild() + `
                        <div class="add-new-section">
                            <label class="form-label" data-bind="click: onClickOpenAddNewModType">Add New</label>
                            <div style="margin-bottom: .5rem;" data-bind="visible: showAddNewModType">
                                <input type="text" class="input-text" id="mod-type" data-bind="value: newModType" required>
                                <button class="btn-form icon i-add" data-bind="click: onClickAddNewModType"></button>
                            </div>
                        </div>
                        <div class="form-group" data-bind="foreach: selectedModTypes" style="margin-left:0;">
                            <span data-bind="text: name"></span>
                            <button class="btn-form icon i-delete" data-bind="click: $parent.onClickRemoveModType"></button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body no-padding">

                    <!-- Primary Image -->
                    <strong class="form-sub-title">Primary Image</strong>
                    <div class="form-group no-padding" style="margin-bottom: .5rem;">
                        <label class="form-label">Primary Image</label>
                    </div>
                    <div class="form-group img" style="margin-bottom: 40px;">
                        ` + this.imageWidgetForPrimaryImage.getHtmlBuild() + `
                    </div>

                    <!-- Files Upload -->
                    <strong class="form-sub-title">Files Upload</strong>
                    ` + this.fileUploader.getHtmlBuild() + `

                    <strong class="form-sub-title">Description</strong>
                    <!-- Mod Description -->
                    <div class="form-group">
                        <label for="descriptionText" class="form-label">Description</label>
                        <textarea id="descriptionText" data-bind="value: description" ></textarea>
                    </div>

                </div>

                <div class="form-body no-padding">

                    <!-- Other Images -->
                    <strong class="form-sub-title">Other Images</strong>
                    <div class="form-group no-padding" style="margin-bottom: .5rem;">
                        <label class="form-label">Other Images</label>
                    </div>
                    <div class="form-group img">
                        ` + this.imageWidgetForOtherImages.getHtmlBuild() + `
                        <div data-bind="foreach: otherImages" class="other-images">
                            <div class="w-img">
                                <img data-bind="attr: { src: url }"/>
                                <button class="btn-form icon i-delete" data-bind="click: $parent.onClickRemoveImage"></button>
                            </div>
                        </div>
                    </div>

                    <!-- Version Number -->
                    <strong class="form-sub-title">Version</strong>
                    <div class="form-group">
                        <label for="version" class="form-label form-label-box">Current Version</label>
                        <input type="text" class="input-text" id="version" data-bind="value: version" required>
                    </div>

                    <!-- instructions Instructions -->
                    <strong class="form-sub-title">Instructions</strong>
                    <div class="form-group">
                        <div class="w-tooltips-adv pos-top short row">
                            <label for="instructions" class="form-label form-label-box">Instructions</label>
                            ` + this.instructionsTooltip.getHtmlBuild() + `
                        </div>
                        <textarea id="instructionsText" data-bind="value: instructions"></textarea>
                    </div>

                </div>
                <div class="generic-modal"><!-- button type="button" class="btn show-file-content" data-bind="event: { click: onClickSeeContent }" >X</button -->
                </div>
            </div>


            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {

        this.userFilter = new filterWebsiteUser_template("userFilter", this.getTemplateViewModel(), this.caller);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller, this.caller.getVnAppZone(), this.caller);

        this.imageWidgetForPrimaryImage = new imageWidget_template("primary_image", this.getTemplateViewModel(), this);
        this.imageWidgetForPrimaryImage.setMode("single-select");
        this.imageWidgetForPrimaryImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForOtherImages = new imageWidget_template("other_images", this.getTemplateViewModel(), this);
        this.imageWidgetForOtherImages.setMode("single-select");
        this.imageWidgetForOtherImages.setCaller(this.imagePickerHelper);

        this.filterTagByType = new filterAutocomplete_template('filterTagByType', this.getTemplateViewModel(), this.caller);
        this.filterTagByType.setAddNewOptionEnabled(false);
        this.filterTagByType.setHasDisplayNameComplement(false);
        this.filterTagByType.setNumberOfChars(3);
        this.filterTagByType.setPlaceholderAndLabel("Game Tag");
        this.filterTagByType.setOptionType("title");

        this.filterModType = new filterTag_template('filterModType', this.getTemplateViewModel(), this.caller);
        this.filterModType.setPlaceholderText("Mod Type");
        this.filterModType.setShowType(false);

        this.fileUploader = new modFileUploader_template("fileUploader", this.getTemplateViewModel(), this.caller);

        this.instructionsTooltip = new infoButton_template('instructionsTooltip', this.getTemplateViewModel(), this.caller)
        this.instructionsTooltip.setTitle('Overview');
        this.instructionsTooltip.setContent(`<p>Press Enter to create a new line. Each line will be treated as a separate bulleted item on the website.</p>`);
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            id: ko.observable(""),
            title: ko.observable(""),
            shortDescription: ko.observable(""),
            primaryImage: ko.observable(""),
            otherImages: ko.observableArray([]),
            status: ko.observableArray([]),
            selectedStatus: ko.observable(null),
            isAdultOnly: ko.observable(false),
            ggpOptIn: ko.observable(false),
            newModType: ko.observable(""),
            showAddNewModType: ko.observable(false),
            selectedModTypes: ko.observableArray([]),
            version: ko.observable(""),
            instructions: ko.observable(""),
            description: ko.observable(""),
            imagePickerTarget: ko.observable(null),
            onClickCancelEdit: function() {
                self.onClickCancelEdit();
            },
            onClickSave: function() {
                self.onClickSave();
            },
            onClickRemoveImage: function(image) {
                self.removeImage(image);
            },
            onClickRemoveModType: function(modType) {
                self.removeModType(modType);
            },
            onClickOpenAddNewModType: function () {
                self.toggleAddNewModType();
            },
            onClickAddNewModType: function () {
                self.addNewModType();
            },
            onClickSeeContent: function (data, event) { self.onClickSeeContent(data, event) }
        }
    }

    protected getTemplateName(): string {

        return "modEdit_template";
    }

    public setModData(data): void {

        const vm = this.getTemplateViewModel();
        vm.id(data.id || "");
        vm.title(data.title || "");;
        vm.shortDescription(data.shortDescription != null && data.shortDescription !== undefined ? String(data.shortDescription) : "");
        vm.description(data.description || "");
        vm.version(data.version || "");
        vm.instructions(data.instructions || "");
        vm.selectedModTypes(data.modTypes || []);
        vm.selectedStatus(data.status ? data.status.id : null);
        vm.isAdultOnly(!!data.isAdultOnly);
        vm.ggpOptIn(data.ggpOptIn === 1 || data.ggpOptIn === true || data.ggpOptIn === '1');
        this.filterTagByType.setOption(data.tag || null);
        this.caller.setDescriptionText(data.description || "");
        this.caller.setInstructionsText(data.instructions || "");

        //set modder info
        if(data.modderInfo){
            this.userFilter.setUserInfo(data.modderInfo);
        }

        //set images
        for (let i = 0; i < data.modImages.length; i++) {

            if(data.modImages[i].isPrimary){
                this.imageWidgetForPrimaryImage.setImage(data.modImages[i].image);
                this.updateImages(data.modImages[i], true, true);
            }else{
                this.updateImages(data.modImages[i], false, true);
            }
        }

        //set files
        this.fileUploader.setEnabled(data.modderInfo ? true : false);
        this.fileUploader.setFiles(data.modFiles || []);

    }

    public getViewModelForRequest() {

        const vm = this.getTemplateViewModel();

        return {

            id: vm.id(),
            title: vm.title(),
            shortDescription: vm.shortDescription(),
            idAccessPointUser: this.userFilter.getTemplateViewModel().idUser(),
            idStatus: vm.selectedStatus(),
            isAdultOnly: !!vm.isAdultOnly(),
            ggpOptIn: !!vm.ggpOptIn(),
            tag: this.filterTagByType.getOptionObj(),
            modTypes: vm.selectedModTypes(),
            primaryImage: vm.primaryImage(),
            otherImages: vm.otherImages(),
            files: this.fileUploader.getFiles(),
            version: vm.version(),
            instructions: this.caller.getInstructionsText(),
            description: this.caller.getDescriptionText(),
        };
    }

    protected onClickCancelEdit(): any {

        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {

        this.caller.save()
    }

    protected setStatus(data): void {

        this.getTemplateViewModel().status(data);
    }

    public showImagePicker(mode,target, keyword = null){

        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(target);
        this.caller.getImageData(keyword);
        this.imagePicker.show();
    }

    public setImagePickerTarget(imagePickerTarget){

        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    //other images
    public updateImages(image, isPrimary, isExistingImage) {

        let data = {
                id:  isExistingImage ? image.id : "",
                idImage : isExistingImage ? image.image.id : image.id,
                url: isExistingImage ? image.image.url : image.url,
            }

        if (isPrimary) {
            this.getTemplateViewModel().primaryImage(data);
        }else {
            let otherImages = this.getTemplateViewModel().otherImages();
            let index = otherImages.findIndex(x => x.idImage == image.id);
            if (index == -1) {
                otherImages.push(data);
            }
            this.getTemplateViewModel().otherImages(otherImages);
        }
    }

    public removeImage(image){

        let otherImages = this.getTemplateViewModel().otherImages();
        let index = otherImages.indexOf(image);
        if(index > -1){
            otherImages.splice(index, 1);
        }

        this.getTemplateViewModel().otherImages(otherImages)
    }

    //mod types
    public updateSelectedModTypes() {
        
        const selectedModType = this.filterModType.getTemplateViewModel().tagObj();
        let selectedModTypes = this.getTemplateViewModel().selectedModTypes();

        if (!selectedModType || selectedModType.name === "" || selectedModType.id == null || selectedModType.id === "null") {
            return;
        }

        // Check if a tag with the same id or name already exists
        const exists = selectedModTypes.some(t => t.id === selectedModType.id || t.name === selectedModType.name);
        if (!exists) {
            selectedModTypes.push(selectedModType);
        }

        this.getTemplateViewModel().selectedModTypes(selectedModTypes);
        this.filterModType.clearInput();
    }


    public removeModType(modType){

        let selectedModTypes = this.getTemplateViewModel().selectedModTypes();
        let index = selectedModTypes.indexOf(modType);
        if(index > -1){
            selectedModTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedModTypes(selectedModTypes)
    }

    public toggleAddNewModType() {

        this.getTemplateViewModel().showAddNewModType(!this.getTemplateViewModel().showAddNewModType());
    }

    protected addNewModType() {

        const newModTypeValue = this.getTemplateViewModel().newModType().trim();
        if (newModTypeValue === '') return;

        let selectedModTypes = this.getTemplateViewModel().selectedModTypes();

        // Check for duplicates
        const exists = selectedModTypes.some(modType => modType.name.toLowerCase() === newModTypeValue.toLowerCase());
        if (exists) {
            this.getTemplateViewModel().newModType(''); // clear input
            return;
        }

        selectedModTypes.push({ id: null, name: newModTypeValue });
        this.getTemplateViewModel().selectedModTypes(selectedModTypes);

        this.getTemplateViewModel().newModType('');
        this.toggleAddNewModType();
    }


    public onClickSeeContent(data, event){
        console.log('Mod Edit', event);
        this.caller.seeContent(data, event);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/modEdit_template.ts